module.exports = __webpack_public_path__ + "img/dz.767ecce4.png";